import { createContext, useContext, useMemo } from 'react';
import { ReducedAccount } from 'Types';

export type CurrencySymbol = '€' | '$' | 'US$';
interface IMenuContext extends ReducedAccount {
  currency_symbol: CurrencySymbol;
}

const initialState: IMenuContext = {
  slug: '',
  business_name: '',
  description: '',
  currency: 'EUR',
  currency_symbol: '€',
  features: 'CATALOGO',
  whatsapp: '',
  instagram: '',
  facebook: '',
  navbarDesign: {
    backgroundColor: '#000000',
    textColor: '#FFFFFF',
    title: '',
    subtitle: '',
  },
  bodyDesign: {
    bannerInfo: '',
  },
  menuLayout: 'CARD',
  cart: {
    additionalFields: [],
  },
};
const MenuContext = createContext<IMenuContext>(initialState);

interface Props {
  account: ReducedAccount | null;
  children: React.ReactNode;
}

const getCurrencySymbol = (currency: 'EUR' | 'USD' | 'PES'): CurrencySymbol => {
  switch (currency) {
    case 'EUR':
      return '€';
    case 'PES':
      return '$';
    case 'USD':
      return 'US$';
  }
};

const MenuProvider: React.FC<Props> = ({ children, account }) => {
  const state: IMenuContext = useMemo(
    () =>
      account
        ? { currency_symbol: getCurrencySymbol(account.currency), ...account }
        : initialState,
    [account]
  );

  return <MenuContext.Provider value={state}>{children}</MenuContext.Provider>;
};

export default MenuProvider;

export const useMenuContext = () => {
  const context = useContext(MenuContext);

  if (context === undefined) {
    throw new Error('useUserContext should be used inside a User provider');
  }
  return context;
};
